import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { ZONES } from '../config/zones';
import { useStore } from '../store';
import { shared } from './shared';

// In Ground/Boat mode, the Eagle auto-triggers a zone briefing when you arrive at a clearing.
export default function ProximityGuide() {
  const last = useRef(-1);
  const acc = useRef(0);

  useFrame((_, delta) => {
    acc.current += delta;
    if (acc.current < 0.25) return;
    acc.current = 0;

    const s = useStore.getState();
    if (!s.entered || s.tourActive || s.narrating) return;
    if (s.mode !== 'suv' && s.mode !== 'boat') return;

    const x = shared.camPos.x;
    let nearest = -1;
    let best = 20; // trigger radius along the river
    ZONES.forEach((z) => {
      const d = Math.abs(z.x - x);
      if (d < best) { best = d; nearest = z.index; }
    });

    if (nearest === -1) {
      last.current = -1; // left all clearings — allow re-trigger later
    } else if (nearest !== last.current) {
      last.current = nearest;
      shared.briefX = ZONES[nearest].x; // Echo Effect: macaws circle above the briefed zone
      shared.briefT = Date.now();
      s.narrateZone(nearest);
    }
  });

  return null;
}
